/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_InboxInputs */

const en_mk_shot_inbox = /** @type {(inputs: Mk_Shot_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A unified inbox of mentions, new comments and approval requests waiting on you.`)
};

const id_mk_shot_inbox = /** @type {(inputs: Mk_Shot_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox terpadu berisi mention, komentar baru, dan permintaan approval yang menunggu.`)
};

/**
* | output |
* | --- |
* | "A unified inbox of mentions, new comments and approval requests waiting on you." |
*
* @param {Mk_Shot_InboxInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_inbox = /** @type {((inputs?: Mk_Shot_InboxInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_InboxInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_inbox(inputs)
	return en_mk_shot_inbox(inputs)
});